import React, { useEffect, useState } from 'react';
import { withSnackbar } from 'notistack';

import { ScreenTitle } from '../../../../components/atoms';
import LoadingModal from '../../../../components/atoms/LoadingModal';
import HistoryView from './HistoryView';
import ChallengeList from '../../SimulatedTests/ChallengeList/index';

const Challenges = ({
  state,
  userId,
  sessionToken,
  loading,
  challengeHistoryList = [],
  challengeAcceptList = [],
  enqueueSnackbar,
  fetchChallengeAcceptList = () => {
  },
  fetchChallengeHistoryList = () => {
  },
}) => {
  const [showCompnany, set_showCompany] = useState(true);
  const [showHistory, set_showHistory] = useState(false);
  const [challengeHistory, setChallengeHistory] = useState([]);
  const [recievedChallenges, setRecievedChallenges] = useState([]);

  useEffect(() => {
    fetchChallengeAcceptList({ userId, sessionToken }, (message, type) => {
      if (type !== 'success') {
        enqueueSnackbar(message, {
          variant: type,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        });
      }
    });
    fetchChallengeHistoryList({ userId, sessionToken }, (message, type) => {
      if (type !== 'success') {
        enqueueSnackbar(message, {
          variant: type,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        });
      }
    });
  }, []);

  useEffect(() => {
    setRecievedChallenges(challengeAcceptList);
  }, [challengeAcceptList]);

  useEffect(() => {
    setChallengeHistory(challengeHistoryList);
  }, [challengeHistoryList]);

  const renderChallenges = () => {
    // const onPressReceivedChallengeBtn = () => {
    //   fetchChallengeAcceptList({
    //     userId: CommonReducer.userId,
    //     sessionToken: sessionToken
    //   });

    //   fetchChallengeHistoryList({
    //     userId: userId,
    //     sessionToken: sessionToken
    //   });

    // }

    return (
      <div
        className='simulated_results challenge-list-container'
        style={{
          border: 'none',
          borderRadius: 0,
          borderTop: '2px solid rgba(0, 0,0,0.09)',
        }}
      >
        {showCompnany && (
          // <p>{"1"}</p>
          <ChallengeList
            data={recievedChallenges}
            acceptBtn={true}
            fallbackText={'No challenge received.'}
            // userName={userName}
            // send_or_recieve={"send"}
            // challengeSentTo={challengeSentTo}
          />
        )}
        {showHistory && (
          // <p>{"2"}</p>
          <HistoryView
            data={challengeHistory}
            // userName={userName}
            // send_or_recieve={"send"}
            // challengeSentTo={challengeSentTo}
          />
        )}
      </div>
    );
  };

  const styless = {
    cancelBtnWrapper: {
      position: 'absolute',
      right: 15,
      top: 15,
      cursor: 'pointer',
    },
    cancelIcon: {
      color: '#fff',
      fontSize: 30,
    },
    linkStyle: {
      cursor: 'pointer',
      margin: 15,
      padding: 5,
    },
  };
  return (
    <>
      <ScreenTitle title={'Dashboard'} subTitle={'Challenges'}/>
      {loading ? (
        <LoadingModal isVisible={loading}/>
      ) : (
        <div className='challenge-container'>
          <ul className='d-flex align-items-center card_tab'>
            <li
              style={{
                ...styless.linkStyle,
                ...(showCompnany
                  ? { borderBottom: '2px solid #1b3665', color: '#7dbf43' }
                  : null),
              }}
              onClick={() => {
                set_showCompany(true);
                set_showHistory(false);
                // getlistdata(0, "send");
              }}
            >
              Received
            </li>
            <li
              style={{
                ...styless.linkStyle,
                ...(showHistory
                  ? { borderBottom: '2px solid #1b3665', color: '#7dbf43' }
                  : null),
              }}
              onClick={() => {
                set_showHistory(true);
                set_showCompany(false);
                // getlistdata(1, "send");
              }}
            >
              History
            </li>
          </ul>

          {renderChallenges()}
        </div>
      )}
    </>
  );
};

export default withSnackbar(Challenges);
